var _G, _Defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { G, Ellipse, Mask, Path, Circle, Defs, LinearGradient, Stop, ClipPath } from "react-native-svg";
/* SVGR has dropped some elements not supported by react-native-svg: filter */
var SvgDefaultMarker = function SvgDefaultMarker(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 43,
    fill: "none",
    viewBox: "0 0 27 43"
  }, props), _G || (_G = /*#__PURE__*/React.createElement(G, {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement(G, {
    filter: "url(#b)"
  }, /*#__PURE__*/React.createElement(Ellipse, {
    cx: 13.5,
    cy: 39.5,
    fill: "black",
    fillOpacity: 0.12,
    rx: 4.5,
    ry: 2.5
  })), /*#__PURE__*/React.createElement(Mask, {
    id: "d",
    width: 27,
    height: 40,
    x: 0,
    y: 0,
    fill: "black",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Path, {
    fill: "white",
    d: "M0 0h27v40H0z"
  }), /*#__PURE__*/React.createElement(Path, {
    d: "M13.5 1C20.404 1 26 6.596 26 13.5c0 2.814-.93 5.41-2.5 7.5-2.5 3.5-9 8-9 17a1 1 0 1 1-2 0c0-9-6.5-13.5-9-17A12.44 12.44 0 0 1 1 13.5C1 6.596 6.596 1 13.5 1"
  })), /*#__PURE__*/React.createElement(Path, {
    fill: "#EA352B",
    d: "M13.5 1C20.404 1 26 6.596 26 13.5c0 2.814-.93 5.41-2.5 7.5-2.5 3.5-9 8-9 17a1 1 0 1 1-2 0c0-9-6.5-13.5-9-17A12.44 12.44 0 0 1 1 13.5C1 6.596 6.596 1 13.5 1"
  }), /*#__PURE__*/React.createElement(Path, {
    fill: "url(#c)",
    d: "m23.5 21-.8-.6-.007.009-.007.01zm-20 0 .814-.581-.007-.01-.007-.01zm10-20v1C19.851 2 25 7.149 25 13.5h2C27 6.044 20.956 0 13.5 0zM26 13.5h-1c0 2.59-.856 4.977-2.3 6.9l.8.6.8.6a13.44 13.44 0 0 0 2.7-8.1zM23.5 21l-.814-.581c-.581.814-1.403 1.696-2.386 2.775-.963 1.057-2.044 2.265-3.049 3.659C15.23 29.657 13.5 33.233 13.5 38h2c0-4.233 1.52-7.407 3.374-9.978.932-1.293 1.946-2.43 2.904-3.481.94-1.031 1.867-2.024 2.536-2.96zm-9 17h-1v2a2 2 0 0 0 2-2zm-1 1v-1h-2a2 2 0 0 0 2 2zm-1-1h1c0-4.767-1.73-8.343-3.751-11.147-1.005-1.394-2.086-2.602-3.049-3.66-.983-1.078-1.805-1.96-2.386-2.774L3.5 21l-.814.581c.669.936 1.597 1.929 2.536 2.96.958 1.052 1.972 2.188 2.904 3.481C9.98 30.592 11.5 33.767 11.5 38zm-9-17 .8-.6A11.44 11.44 0 0 1 2 13.5H0c0 3.038 1.006 5.844 2.7 8.1zM1 13.5h1C2 7.149 7.149 2 13.5 2V0C6.044 0 0 6.044 0 13.5z",
    mask: "url(#d)"
  }), /*#__PURE__*/React.createElement(Circle, {
    cx: 13.5,
    cy: 13.5,
    r: 4.5,
    fill: "black",
    fillOpacity: 0.4
  }))), _Defs || (_Defs = /*#__PURE__*/React.createElement(Defs, null, /*#__PURE__*/React.createElement(LinearGradient, {
    id: "c",
    x1: 13.5,
    x2: 13.5,
    y1: 1,
    y2: 39,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.35
  })), /*#__PURE__*/React.createElement(ClipPath, {
    id: "a"
  }, /*#__PURE__*/React.createElement(Path, {
    fill: "white",
    d: "M0 0h27v43H0z"
  })))));
};
export default SvgDefaultMarker;